
import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const CompanySize = () => {
  return (
    <SettingsMetaData propertyName={"CompanySize_leads"} viewPropertyName={"Company Size"} />
  );
};
export default CompanySize;
